import { queryOptions } from "@tanstack/react-query";

import { apiFetch } from "../lib/api";
import type { ReviewQueueFilters, ReviewQueueResponse } from "./types";

function toQueryString(filters: ReviewQueueFilters): string {
  const params = new URLSearchParams();
  if (filters.status) params.set("status", filters.status);
  if (filters.source) params.set("source", filters.source);
  if (filters.severity) params.set("severity", filters.severity);
  if (filters.project_id) params.set("project_id", filters.project_id);
  const qs = params.toString();
  return qs ? `?${qs}` : "";
}

export const reviewQueueQueryOptions = (filters: ReviewQueueFilters = {}) =>
  queryOptions({
    queryKey: ["review-queue", filters] as const,
    queryFn: () =>
      apiFetch<ReviewQueueResponse>(`/review-queue${toQueryString(filters)}`),
  });
